
import React, { useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from 'react-router-dom';
import { FaChevronDown, FaSignOutAlt, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import axios from 'axios';
import APIEndPoints from "../../middleware/APIEndPoints";


const Sidebar = ({ open, setOpen }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [managementOpen, setManagementOpen] = useState(false);
    const [supportOpen, setSupportOpen] = useState(false);
    const [clientsOpen, setClientsOpen] = useState(false);
    const [showLogoutConfirmation, setShowLogoutConfirmation] = useState(false);
    const navigate = useNavigate();

    const getSignOutURl = APIEndPoints.sign_out.url;

    const handleLogout = async () => {
        try {
            await axios.post(getSignOutURl, {}, { withCredentials: true });

            localStorage.removeItem('user'); // Replace 'user' with the actual key storing user data

            alert("Logged out successfully.");
            navigate('/'); // Redirect to login page after logout
        } catch (err) {
            console.error("Logout error:", err);
            alert("Logout failed.");
        }
    };


    return (
        <div className="fixed z-30">
            {/* Sidebar */}
            <div className={`fixed top-0 left-0 h-screen ${open ? "w-64 transition-all duration-[1200ms]" : "w-0 left-[-3000px] md:left-0 md:w-64 transition-all duration-[3500ms] md:duration-75"} bg-gray-900 text-white p-4 flex flex-col transition-all duration-300 overflow-hidden md:w-64 md:relative z-50 overflow-y-auto`}>
                {/* Heading & Logo */}
                <div className="flex items-center justify-between sm:justify-start space-x-2 pb-4 border-b border-gray-700">
                    <div className="w-10 h-10 bg-white rounded-full"></div> {/* Placeholder for Logo */}
                    <h1 className="text-xl font-bold md:block">WhyAdmin</h1>
                    <button
                        onClick={() => setOpen(prev => !prev)}
                        className="md:hidden p-2 bg-gray-800 text-white rounded-md"
                    >
                        <FaTimes size={24} />
                    </button>
                </div>
                <div>

                </div>

                {/* Sidebar Content - Scrollable */}
                <div className="mt-4 space-y-2 flex-grow overflow-y-auto">
                    {/* Menu */}
                    <div>
                        <div className="cursor-pointer flex justify-between items-center p-2 rounded-md hover:bg-gray-800" onClick={() => setMenuOpen(!menuOpen)}>
                            <span>Menu</span>
                            <FaChevronDown className={`text-white transform ${menuOpen ? "rotate-180" : "rotate-0"}`} />
                        </div>
                        {menuOpen && (
                            <motion.div initial={{ height: 0 }} animate={{ height: "auto" }} className="ml-4 space-y-2">
                                <Link to='/admin-abhijan-home/dashboard' className="text-[1.1rem] text-white"><div className="p-2 hover:bg-gray-800 rounded-md">Dashboard </div></Link>
                                <Link to='/admin-abhijan-home/my-cv' className="text-[1.1rem] text-white"><div className="p-2 hover:bg-gray-800 rounded-md">My CV </div></Link>
                                <Link to='/admin-abhijan-home/my-education' className="text-[1.1rem] text-white"><div className="p-2 hover:bg-gray-800 rounded-md">My Education </div></Link>
                                <Link to='/admin-abhijan-home/my-working-history' className="text-[1.1rem] text-white"><div className="p-2 hover:bg-gray-800 rounded-md">My Working History </div></Link>
                                <Link to='/admin-abhijan-home/my-skills-admin' className="text-[1.1rem] text-white"><div className="p-2 hover:bg-gray-800 rounded-md">My Skills </div></Link>

                            </motion.div>
                        )}
                    </div>

                    {/* Management */}
                    <div>
                        <div className="cursor-pointer flex justify-between items-center p-2 rounded-md hover:bg-gray-800" onClick={() => setManagementOpen(!managementOpen)}>
                            <span>Management</span>
                            <FaChevronDown className={`text-white transform ${managementOpen ? "rotate-180" : "rotate-0"}`} />
                        </div>
                        {managementOpen && (
                            <motion.div initial={{ height: 0 }} animate={{ height: "auto" }} className="ml-4 space-y-2">
                                <Link to='/admin-abhijan-home/projects' className="text-[1.1rem] text-white"><div className="p-2 hover:bg-gray-800 rounded-md">Projects </div></Link>
                                <Link to='/admin-abhijan-home/my-services-admin' className="text-[1.1rem] text-white"><div className="p-2 hover:bg-gray-800 rounded-md">Services </div></Link>
                                <Link to='/admin-abhijan-home/my-blogs-admin' className="text-[1.1rem] text-white"><div className="p-2 hover:bg-gray-800 rounded-md">Blogs </div></Link>
                            </motion.div>
                        )}
                    </div>

                    {/* Support */}
                    <div>
                        <div className="cursor-pointer flex justify-between items-center p-2 rounded-md hover:bg-gray-800" onClick={() => setSupportOpen(!supportOpen)}>
                            <span>Support</span>
                            <FaChevronDown className={`text-white transform ${supportOpen ? "rotate-180" : "rotate-0"}`} />
                        </div>
                        {supportOpen && (
                            <motion.div initial={{ height: 0 }} animate={{ height: "auto" }} className="ml-4 space-y-2">
                                <Link to='/admin-abhijan-home/my-contact-list-admin' className="text-[1.1rem] text-white"><div className="p-2 hover:bg-gray-800 rounded-md">Contact List </div></Link>
                                <Link to='/admin-abhijan-home/work-with-me-admin' className="text-[1.1rem] text-white"><div className="p-2 hover:bg-gray-800 rounded-md">Work With Me List </div></Link>
                            </motion.div>
                        )}
                    </div>

                    {/* Clients */}
                    <div>
                        <div className="cursor-pointer flex justify-between items-center p-2 rounded-md hover:bg-gray-800" onClick={() => setClientsOpen(!clientsOpen)}>
                            <span>My Clients</span>
                            <FaChevronDown className={`text-white transform ${clientsOpen ? "rotate-180" : "rotate-0"}`} />
                        </div>
                        {clientsOpen && (
                            <motion.div initial={{ height: 0 }} animate={{ height: "auto" }} className="ml-4 space-y-2">
                                <Link to='/admin-abhijan-home/satisfied-clients' className="text-[1.1rem] text-white"><div className="p-2 hover:bg-gray-800 rounded-md">Client Reviews</div></Link>
                            </motion.div>
                        )}
                    </div>
                </div>

                {/* Logout */}
                <div className="mt-4">

                    <div onClick={() => setShowLogoutConfirmation(true)} className="flex items-center p-2 rounded-md hover:bg-red-600 cursor-pointer">
                        <FaSignOutAlt className="text-white" />
                        <span className="ml-2">Logout</span>
                    </div>
                </div>
            </div>
            {/* LOGOUT CONFIRMATION MODAL */}
            {showLogoutConfirmation && (
                <div className='fixed  top-0 left-0 w-full h-full bg-black bg-opacity-90 flex justify-center items-center z-50'>
                    <div className='bg-white p-6 rounded shadow-lg text-center text-black'>
                        <p className='mb-4'>Are you sure you want to log out?</p>
                        <div className='flex justify-center space-x-4'>
                            <button
                                onClick={handleLogout}
                                className='bg-red-500 text-white px-4 py-2 rounded'
                            >
                                Yes
                            </button>
                            <button
                                onClick={() => setShowLogoutConfirmation(false)}
                                className='bg-gray-500 text-white px-4 py-2 rounded'
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Sidebar;